module.exports = __webpack_public_path__ + "img/senalando-izqni.a666ced1.png";